document.addEventListener("DOMContentLoaded", function () {
  const parentSelector = ".mobile-sort-bottom";
  const selectSelector = "select[name='sort_by']";

  // Event delegation on document
  document.addEventListener("change", function (e) {
    const changedSelect = e.target;

    // Only run if inside .mobile-sort-bottom and is sort_by select
    if (
      changedSelect.matches(selectSelector) &&
      changedSelect.closest(parentSelector)
    ) {
      const selectedValue = changedSelect.value;

      // Update all sort_by selects on page
      document.querySelectorAll(selectSelector).forEach((select) => {
        if (select !== changedSelect) {
          select.value = selectedValue;

          // Trigger change event for theme listeners (important)
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const isMobile = window.matchMedia("(max-width: 767px)");

  if (!isMobile.matches) return;

  const stickyFilters = document.querySelector(".sticky-collection-filters");
  const banner = document.querySelector(".collection-banner--description");
  const footer = document.querySelector("footer");

  if (!stickyFilters) return;

  let bannerVisible = false;
  let footerVisible = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === banner) {
        bannerVisible = entry.isIntersecting;
      }

      if (entry.target === footer) {
        footerVisible = entry.isIntersecting;
      }
    });

    if (bannerVisible || footerVisible) {
      stickyFilters.classList.add("hidden");
    } else {
      stickyFilters.classList.remove("hidden");
    }
  });

  if (banner) observer.observe(banner);
  if (footer) observer.observe(footer);
});